// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { resetPropertyForm } from "../../property/inputFieldSlices/propertyInputSlice";
// import { clearUserData } from "../../user/userSlice";
// import { clearLoggedInUserData } from "../authSlice";

// import { persistor } from "../../../app/store";

// function Logout() {
//   //debugger;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const ReduxState = useSelector((state) => state);

//   useEffect(() => {
//     console.log("Clearing session and local storage...");

//     // Clear session and local storage
//     sessionStorage.clear();
//     localStorage.clear();

//     // Check if storage is actually cleared
//     console.log("Session storage after clear:", sessionStorage);
//     console.log("Local storage after clear:", localStorage);

//     console.log("Purging persisted state...");
//     persistor.purge().then(() => {
//       console.log("Persisted state purged",state);

//       // Dispatch actions to reset state
//       console.log("Dispatching reset actions...");
//       dispatch(resetPropertyForm());
//       dispatch(clearUserData());
//       dispatch(clearLoggedInUserData());

//       console.log("redux local storage=", ReduxState);

//       // Redirect to Login page
//       console.log("Navigating to Login page...");
//       navigate("/Login");
//     });
//   }, []);

//   // Return null or a loading indicator, since there's no UI to render after logout
//   return null;
// }

// export default Logout;

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetPropertyForm } from "../../property/inputFieldSlices/propertyInputSlice";
import { clearUserData } from "../../user/userSlice";
import { clearLoggedInUserData } from "../authSlice";
import { persistor } from "../../../app/store";
import { resetPropertyState } from "../../property/propertySlice";
import { resetTimeSlab } from "../../OnlineAppointment/OnlineAppointmentSlice";
import { clearTranslation } from "../../Translate/TranslateSlice";

function Logout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const ReduxState = useSelector((state) => state);

  useEffect(() => {
    const clearAndReset = async () => {
      console.log("Clearing session and local storage...");
      sessionStorage.clear();
      localStorage.clear();

      // Ensure storage is cleared
      console.log("Session storage after clear:", sessionStorage);
      console.log("Local storage after clear:", localStorage);

      // Dispatch actions to reset state
      dispatch(resetPropertyForm());
      dispatch(clearUserData());
      dispatch(clearLoggedInUserData());
      dispatch(resetPropertyState());
      dispatch(resetTimeSlab());
      dispatch(clearTranslation());

      navigate("/Login");
    };

    clearAndReset();
  }, [dispatch, navigate]);

  return null;
}

export default Logout;
